const { selectOptions } = require("common/time_slots/utils");
const { times } = require("ramda");

angular
  .module("ticketco/ticketbuyer/time_slots")
  .component("timeSlotsOrderForm", {
    bindings: {
      promocode: "<",
    },
    templateUrl: "timeSlotsOrderFormComponent.html",
    controller: function controller(TimeSlotsModel) {
      var self = this;
      var selectedItemTypesDestructor;
      self.itemTypes = [];

      self.$onInit = function onInit() {
        selectedItemTypesDestructor = TimeSlotsModel.getSelectedItemTypes(
          function (_, itemTypes) {
            self.itemTypes = itemTypes;
          }
        );
      };

      self.$onDestroy = function onDestroy() {
        selectedItemTypesDestructor();
      };

      self.range = function (max) {
        return times(function (i) {
          return i;
        }, max + 1);
      };

      self.selectOptions = selectOptions;

      self.getMaxAmount = function (itemType) {
        var capacityAmount = TimeSlotsModel.findCapacity(
          itemType.capacityId
        ).$amount();
        return Math.min(
          itemType.amount,
          itemType.max_items_per_order,
          capacityAmount + itemType.selected_amount()
        );
      };

      self.tooltipDiscountCssClass = ({ retail_price, actual_price }) =>
        retail_price !== actual_price ? "" : "hidden";

      self.min = Math.min;
    },
  });
